import { render, staticRenderFns } from "./CreateMessagesWise.vue?vue&type=template&id=12528904&scoped=true&"
import script from "./CreateMessagesWise.vue?vue&type=script&lang=js&"
export * from "./CreateMessagesWise.vue?vue&type=script&lang=js&"
import style0 from "./CreateMessagesWise.vue?vue&type=style&index=0&id=12528904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12528904",
  null
  
)

export default component.exports